export default {"src":"/_next/static/media/twitter.cf7b78d5.svg","height":24,"width":24};